import './index.scss';
import ModalManager from 'utils/modal_manager';
import { errorInterpreter } from 'utils/error_interpreter';
import { handleApiError } from 'utils/api_error_handler';

export default class AbuseReportModal {
  static openForQuestionsCommentary(data) {
    const { commentId, questionId } = data;

    this._verifyTextArea('.q-route-questions-index, .q-route-questions-show');

    ModalManager.open('#js-abuse-report-modal', res => {
      if (res) {
        Thor.Commentary.report_abuse(
          {
            id: commentId,
            question_id: questionId
          },
          {
            data: {
              text: res.justification
            }
          }
        )
          .then(() => {
            ModalManager.open('#js-abuse-report-confirm-modal');
          })
          .catch(({ response }) => {
            errorInterpreter({
              response
            });
          });
      }
    });
  }

  static openForTimelineActivity(data) {
    const { activityId } = data;

    this._verifyTextArea('.q-user-panel-layout');

    ModalManager.open('#js-abuse-report-modal', res => {
      if (res) {
        Thor.Activity.report_abuse(
          {
            id: activityId
          },
          {
            data: {
              text: res.justification
            }
          }
        )
          .then(() => {
            ModalManager.open('#js-abuse-report-confirm-modal');
          })
          .catch(({ response }) => {
            handleApiError(
              'Ops! Você já reportou abuso para esta publicação!',
              response
            );
          });
      }
    });
  }

  static openForTimelineComment(data) {
    const { commentId, activityId } = data;

    this._verifyTextArea('.q-user-panel-layout');

    ModalManager.open('#js-abuse-report-modal', res => {
      if (res) {
        Thor.ActivityComments.report_abuse(
          {
            id: commentId,
            activity_id: activityId
          },
          {
            data: {
              message: res.justification
            }
          }
        )
          .then(() => {
            ModalManager.open('#js-abuse-report-confirm-modal');
          })
          .catch(({ response }) => {
            handleApiError('Ops! Você já reportou este comentário!', response);
          });
      }
    });
  }

  static openForTimelineReply(data) {
    const { replyId, activityCommentId, activityId } = data;

    this._verifyTextArea('.q-user-panel-layout');

    ModalManager.open('#js-abuse-report-modal', res => {
      if (res) {
        Thor.ActivityReplies.report_abuse(
          {
            id: replyId,
            activity_comment_id: activityCommentId,
            activity_id: activityId
          },
          {
            data: {
              message: res.justification
            }
          }
        )
          .then(() => {
            ModalManager.open('#js-abuse-report-confirm-modal');
          })
          .catch(({ response }) => {
            handleApiError('Ops! Você já reportou este comentário!', response);
          });
      }
    });
  }

  static _verifyTextArea($context) {
    $('#js-justification', $context)
      .off('keyup keydown')
      .on('keyup keydown', function () {
        const currentValue = $('#js-justification', $context).val();
        const $justificationButton = $('.js-btn-justification', $context);

        if (currentValue.length >= 3) {
          $justificationButton.removeAttr('disabled');
        } else {
          $justificationButton.attr('disabled', 'disabled');
        }

        $('.js-btn-justification-cancel', $context).on('click', function () {
          $('#js-justification', $context).val('');
          $justificationButton.attr('disabled', 'disabled');
        });
      });
  }
}
